import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from "react-redux";
import {store} from '../src/redux/store';
import App from './App';
import { AuthContextProvider } from './Context/AuthContext';

ReactDOM.render(
  <React.StrictMode>
    <AuthContextProvider>
     <Provider store={store}>
      <App />
    </Provider>
    </AuthContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

